import * as React from 'react'
import {DynamicBlock} from '../components/dynamic/DynamicBlock'
import {DynamicBlockContent} from '../components/dynamic/DynamicBlockContent'
import {DynamicBlockHeader} from '../components/dynamic/DynamicBlockHeader'
import {DynamicField} from '../components/dynamic/DynamicField'
import {DynamicContent} from '../components/dynamic/DynamicContent'
import {Block, getBlock} from './Block'

///////////////////////////////////////////////////////////////////////////////

export enum DynamicComponentType {
  FIELD = 'field',
  BLOCK = 'block',
  BLOCK_HEADER = 'block_header',
  BLOCK_CONTENT = 'block_content',
  CONTENT = 'content',
}

export type DynamicComponents = {
  [key in DynamicComponentType]?: (props: any) => JSX.Element
}

///////////////////////////////////////////////////////////////////////////////

const components: DynamicComponents = {
  [DynamicComponentType.FIELD]: (props: any) => <DynamicField {...props} />,
  [DynamicComponentType.BLOCK]: (props: any) => <DynamicBlock {...props} />,
  [DynamicComponentType.BLOCK_HEADER]: (props: any) => (
    <DynamicBlockHeader {...props} />
  ),
  [DynamicComponentType.BLOCK_CONTENT]: (props: any) => (
    <DynamicBlockContent {...props} />
  ),
  [DynamicComponentType.CONTENT]: (props: any) => <DynamicContent {...props} />,
}

export function getDynamicComponentByType(type: DynamicComponentType | Block) {
  let componentFactory =
    components[type as DynamicComponentType] || getBlock(type as Block)

  if (!componentFactory) {
    throw new Error('Unknown slot component "' + type + '"')
  }

  return componentFactory
}
